/* eslint-disable react/prop-types */
import { cx } from 'emotion';
import React, { CSSProperties, HTMLAttributes, forwardRef } from 'react';

import { DeviceInfo } from '@ezugi/utils';

import {
  Container, ContainerWithoutTheme, disabledClassName, customColorClassName,
} from './style';

type OwnIconProps = {
  svg: string;
  size?: number;
  color?: string;
  /**
   * projection function for the `svg` prop.
   * you can use this to perform transformations on the `svg` prop
   * e.g.:
   * map={(svg) => svg.replace('**FILL_COLOR**', myFillColor)}
   */
  map?: Function,
  disabled?: boolean;
  noDefaultStyling?: boolean;
  style?: CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  preventClick?: boolean;
}

export type IconProps = Omit<HTMLAttributes<HTMLDivElement>, 'onClick'> & OwnIconProps;

const Icon = forwardRef<HTMLDivElement, IconProps>(
  (
    { svg,
      size = 24,
      color,
      style = {},
      map = (x : unknown) => x,
      disabled = false,
      preventClick = false,
      noDefaultStyling = false,
      className,
      onClick,
      ...props },
    ref
  ) => {
    const TagName = noDefaultStyling ? ContainerWithoutTheme : Container;

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (onClick) {
        onClick(e);
      }
    };

    return (
      <TagName
        style={{
          ...(size && { width: size, height: size }),
          ...(color && { color, fill: color }),
          ...(preventClick && { pointerEvents: 'none' }),
          ...style,
          cursor: onClick ? 'pointer' : 'inherit',
        }}
        isHandheld={DeviceInfo.isHandheld}
        ref={ref}
        dangerouslySetInnerHTML={{ __html: map(svg || '') }}
        className={cx({ [disabledClassName]: disabled, [customColorClassName]: Boolean(color) }, className)}
        onClick={preventClick ? undefined : handleClick}
        {...props}
      />
    );
  }
);

export default Icon;
